import React from 'react';
import styles from './Spinner.module.css';

const Spinner: React.FC = () => {
  return (
    <div className={styles.overlay}>
      <img
        src="/assets/images/gear-spinner.svg"
        alt="Loading..."
        className={styles.spinner}
      />
    </div>
  );
};

export default Spinner;

